import { DefaultContent, ErrorCard } from '../layouts';

import { Button } from '..';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const PUBLIC_URL = process.env.PUBLIC_URL;

const AppErrorBoundaryView: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <DefaultContent>
      <ErrorCard>
        <div className="empty-body-card single-card text-center py-2">
          <img className="img-fluid" alt="Comportamento Inesperado" src={`${PUBLIC_URL}${'/assets/images/bot_500.png'}`} />
          <h1 className="display-4">{t('label.comportamento_inesperado')}</h1>
          <p className="lead">{t('texto.pagina_erro')}</p>
          <Button
            className="mt-3"
            title={t('label.pagina_inicial')}
            onClick={() => {
              window.location.href = '/eleicoes';
            }}
          />
        </div>
      </ErrorCard>
    </DefaultContent>
  );
};

export default AppErrorBoundaryView;
